export default (field: any, userProfile: any, insuranceProfile: any, insuranceDetails: any) => {
  if (typeof field === 'function')
    return field({ userProfile, insuranceProfile, insuranceDetails });
  return field;
};
